import React from "react";
import { Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import AssessmentList from "./AssessmentList";

export default function AssessmentManagement({ organizationId = null }) {
  const { t } = useTranslation();

  return (
    <div>
      {!organizationId && (
        <Title order={3} mb="md">
          {t("assessment_plural")}
        </Title>
      )}
      <AssessmentList organizationId={organizationId} />
    </div>
  );
}
